import Axios from 'axios';
import * as Sentry from '@sentry/react';
import { ServerStatusCode, serviceEndpoints, webAppRoutes } from '../constants';
import { AppConfig } from '../typings';

export class InterceptorService {
  private static navigate: (url: string) => void;

  public static init(appConfig: AppConfig): void {
    Axios.defaults.baseURL = appConfig.apiBaseUrl;

    InterceptorService.addResponseInterceptor();
  }

  public static setHistory(navigate: (url: string) => void) {
    this.navigate = navigate;
  }

  private static addResponseInterceptor(): void {
    Axios.interceptors.response.use(undefined, (error) => {
      const isAuthUnauthorizedError =
        error.response?.status === ServerStatusCode.INTERNAL_SERVER_ERROR &&
        error.config?.url === serviceEndpoints.authenticationApi();

      if (!isAuthUnauthorizedError) {
        Sentry.captureException(error, {
          contexts: {
            response: {
              status: error.response?.status,
              data: error.response?.data,
              url: error.config?.url,
              method: error.config?.method,
            },
          },
        });
      }

      if (error && error.isAxiosError && error.response && this.navigate) {
        if (error.response.status === ServerStatusCode.NOT_FOUND) {
          setTimeout(() => {
            this.navigate(webAppRoutes.notFound);
          }, 200);
        } else if (error.response.status === ServerStatusCode.UNAUTHORIZED) {
          window.location.href = webAppRoutes.signIn;
        }
      }

      return Promise.reject(error);
    });
  }
}
